import { createEntityFilterStore } from "./createEntityFilterStore";
import type { InvestmentFilters } from "@/domain/types";

const initialFilters: InvestmentFilters = {
  search: "",
  sort: { key: undefined, direction: null },
};

export const useInvestorInvestmentFiltersStore = createEntityFilterStore<InvestmentFilters>(
  "InvestorInvestmentFiltersStore",
  initialFilters,
);
